import type { FaireProductEntity } from "../../entity_types/product";

export const p_5u9kpvaxrk: FaireProductEntity = {
  token: "p_5u9kpvaxrk",
  type: "product",
  name: "Tie Dye Thigh High | Primary Prism",
  brandToken: "b_cpqsk65pdp",
  brandName: "Soul Shine Maine",
  imageUrl:
    "https://cdn.faire.com/fastly/817d89873a98e9d815ef14407a56b7972cdac03550d4882ef2caff7756e91387.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e81af02ec2f99b356fcb8db05c458f43596c13c305ca0128d31e1719e935a35.jpeg",
    "https://cdn.faire.com/fastly/b3ba00678182f72c51965b77d840ea4828974cbee42ea00644da8fadad674599.jpeg",
  ],
  priceDollars: 18,
  description:
    "Put your best foot forward and shine...\n\nExtra Tall Cotton Tie Dye Thigh High Socks\n\nCOLOR: PRIMARY PRISM\n\nThese are just too cool, comfy and the right amount of sexy...\n\nPerfect paired with some tall boots, scrunched down with sneakers 80's style, or just lounging around the house...\n\nAll our dyes are fiber reactive and stead-fast for durability over time and washing!\n\nProudly made in the USA.\n\n** Due to the organic and unique nature of tie dye all items are one of a kind. You will receive an item similar to the one shown above!",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:42.069Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
